<mat-dialog-content class="mat-typography">
  <section class="add-currency-dialog-wrapper">
    <h2 class="cmn-popup-title">Edit Closing Stock</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <form [formGroup]="editStockForm">
      <div class="currency-form-wrapper">
        <div class="form-wrapper">
          <label for="">Item Name <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter item name"
              formControlName="itemName"
              maxlength="20"
              readonly
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  editStockForm.get('itemName')!.touched &&
                  editStockForm.get('itemName')!.hasError('required')
                "
                >Item Name is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Select date"
              formControlName="date"
              [matDatepickerFilter]="dateFilter"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                    editStockForm.get('date')!?.touched &&
                    editStockForm.get('date')?.hasError('required')"
              >
                Date is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Opening Stock <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter Opening Stock"
              formControlName="openingStock"
              readonly
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  editStockForm.get('openingStock')!.touched &&
                  editStockForm.get('openingStock')!.hasError('required')
                "
                >Opening Stock is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Closing Stock <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              type="number"
              min="0"
              placeholder="Enter Closing Stock"
              formControlName="closingStock"
              (keypress)="validateStockInput($event)"
              (keypress)="allowOnlyInteger($event)"
              (paste)="blockInvalidPaste($event)"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  editStockForm.get('closingStock')!.touched &&
                  editStockForm.get('closingStock')!.hasError('required')
                "
                >Closing Stock is required.</mat-error
              >
            </span>
            <span>
              <mat-error
                *ngIf="editStockForm.get('closingStock')!.hasError('pattern')"
              >
                Only positive numbers are allowed.
              </mat-error>
            </span>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <button class="cmn-popup-btn" type="submit" (click)="onSubmit()">
          Save
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>
